var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3BusWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_6",
    "data-name": "Layer 6",
    viewBox: "0.63 2.81 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-1 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.10963,
    y1: 7.81481,
    x2: 30.14963,
    y2: 7.81481
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.30963,
    y1: 11.81481,
    x2: 43.94963,
    y2: 11.81481
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.26963,
    y1: 38.81481,
    x2: 31.98963,
    y2: 38.81481
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.58963,44.81481v3a1.925,1.925,0,0,0,1.84,2h1.84a1.925,1.925,0,0,0,1.84-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.14963,44.81481v3a1.925,1.925,0,0,0,1.84,2h1.84a1.925,1.925,0,0,0,1.84-2v-3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 9.90963,
    cy: 38.81481,
    rx: 1.84,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 39.34963,
    cy: 38.81481,
    rx: 1.84,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.30963,3.81481h26.64a6,6,0,0,1,6,6v33a2,2,0,0,1-2,2h-34.64a2,2,0,0,1-2-2v-33A6,6,0,0,1,11.30963,3.81481Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.30963,23.81481h-1.84a1.925,1.925,0,0,1-1.84-2v-6a1.925,1.925,0,0,1,1.84-2h1.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.94963,13.81481h1.84a1.925,1.925,0,0,1,1.84,2v6a1.925,1.925,0,0,1-1.84,2h-1.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.30963,29.81481l1.34366.4868a8.53259,8.53259,0,0,0,2.90931.5132H39.69665a8.53264,8.53264,0,0,0,2.90932-.5132l1.34366-.4868"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3BusWhite);
export default __webpack_public_path__ + "static/media/icon_3_bus_white.bb880bd600abfd2c24a4e264765433a8.svg";
export { ForwardRef as ReactComponent };